import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ManageItemsTelemetry } from '../../spaces/Collections/CollectionsTelemetry';
import {
  CreateEmptyCollection,
  CreateNewContentInfoRequest,
  CreateNewFlow,
  CreateNewLens,
  CreateNewProject,
  CreateNewPublishedConnection,
  CreateNewPublishedDataSource,
  CreateNewSchedule,
  CreateNewSite,
  CreateNewWorkbook,
  CreateNoNameCollection,
} from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface CreateNewContentAction extends Action {
  projectId?: string;
}

export interface CreateNewContentInfoRequestAction extends CreateNewContentAction {}

export function createNewContentInfoRequest(): CreateNewContentAction {
  return {
    type: CreateNewContentInfoRequest
  };
}

export interface CreateNewFlowAction extends CreateNewContentAction {}

export function createNewFlow(projectId?: string): CreateNewFlowAction {
  return {
    type: CreateNewFlow,
    projectId,
  };
}

export interface CreateNewLensAction extends CreateNewContentAction {
  publishedDatasourceId: number;
}

export function createNewLens(projectId?: string, publishedDatasourceId?: number): CreateNewLensAction {
  return {
    type: CreateNewLens,
    projectId, publishedDatasourceId,
  };
}

export interface CreateNewProjectAction extends CreateNewContentAction {}

export function createNewProject(projectId: string): CreateNewProjectAction {
  return {
    type: CreateNewProject,
    projectId: projectId
  };
}

export const isCreateNewProjectAction = isActionFactory<CreateNewProjectAction>(CreateNewProject);

export interface CreateNewPublishedDatasourceAction extends CreateNewContentAction {}

export function createNewPublishedDataSource(projectId: string): CreateNewProjectAction {
  return {
    type: CreateNewPublishedDataSource,
    projectId: projectId
  };
}

export const isCreateNewPublishedDataSourceAction = isActionFactory<CreateNewProjectAction>(CreateNewProject);

export interface CreateNewPublishedConnectionAction extends CreateNewContentAction {}

export function createNewPublishedConnection(projectId?: string): CreateNewPublishedConnectionAction {
  return {
    type: CreateNewPublishedConnection,
    projectId: projectId,
  };
}

export interface CreateNewWorkbookAction extends CreateNewContentAction {}

export function createNewWorkbook(projectId?: string): CreateNewContentAction {
  return {
    type: CreateNewWorkbook,
    projectId: projectId
  };
}

export interface CreateNewSiteAction extends CreateNewContentAction {}

export function createNewSite(): CreateNewSiteAction {
  return {
    type: CreateNewSite
  };
}


export interface CreateNewScheduleAction extends CreateNewContentAction {
  scheduleType?: string;
  isEnabledForLinkedTasks?: boolean;
}

export function createNewSchedule(type?: string, isEnabledForLinkedTasks?: boolean): CreateNewScheduleAction {
  return {
    type: CreateNewSchedule,
    scheduleType: type,
    isEnabledForLinkedTasks: isEnabledForLinkedTasks,
  };
}

// When creating a collection via the ManageItemsInCollectionDialog and CreateCollectionDialog
// Used when a user provides a collection name
export interface CreateEmptyCollectionAction extends CreateNewContentAction {
  itemsToPossiblyAdd?: IContentInfo[];
  manageItemsTelemetry?: ManageItemsTelemetry;
}

export function createEmptyCollectionAction(itemsToPossiblyAdd?: IContentInfo[], manageItemsTelemetry?: ManageItemsTelemetry): CreateEmptyCollectionAction {
  return {
    type: CreateEmptyCollection,
    itemsToPossiblyAdd,
    manageItemsTelemetry
  };
}

// When create a collection via the Create Button and a user provides no name for the collection
export interface CreateNoNameCollectionAction extends CreateNewContentAction {}

export function createNoNameCollectionAction(): CreateNoNameCollectionAction {
  return {
    type: CreateNoNameCollection
  };
}
